export const UsernamePattern = '^[a-z0-9_\\.@]{4,50}$';
export const UsernamePatternErrorMessage =
  'Username must be at least 4 characters long and alphabetic letters should be only lowercase. Can also contain numbers and special symbols: ".", "@"';
